export enum AttachmentAsOptions {
  Link = 'Link',
  File = 'File'
}
